import React from 'react'
import './AboutUsBanner.css'

function AboutUsBanner() {
  return (
    <div className='aboutusbanner'>
      {/* contact us banner */}
        <h1>World of Mayaluss </h1>
        
        <p>We created these clothes for those people who are here to conquer.</p>
        <p>If this were 1,000 years ago, we made these for the Mayaluss who would come on unicorn and burn armies alone.</p>
    </div>
  )
}

export default AboutUsBanner